import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-side-menu-content',
  standalone: true,
  imports: [],
  templateUrl: './side-menu-content.component.html',
  styleUrl: './side-menu-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
// eslint-disable-next-line @tseslint/no-extraneous-class
export class SideMenuContentComponent {}
